import { Box, Button, CloudinaryImage, Stack, Text } from '@stitch-fix/mode-react';
import { useRouter } from 'next/router';
export const DesktopNoGallery = () => {
  const router = useRouter();
  return <Stack spacing={2} mt={3} hAlign="center">
      <Text color="blue-45" setting="display-medium" align="center">
        Your Vision <strong>Gallery</strong>
      </Text>
      <Box>
        <Text setting="body-large" align="center">
          Your first images will be ready in about 10 minutes.
        </Text>
        <Text setting="body-large" align="center">
          Simply refresh this page when it’s time!
        </Text>
      </Box>
      <Box width="200px" mx="auto">
        <CloudinaryImage baseUrl="https://res.cloudinary.com/stitch-fix/image/upload/" mediaPath="v1757013953/vision/assets/9-2-loading-gallery.gif" sizes={{
        sm: 600
      }} transforms={{
        f: 'auto',
        q: 'auto'
      }} alt="" objectFit="cover" />
      </Box>
      <Text setting="body-small" align="center">
        (You can find your Vision Image Gallery in your Account settings.)
      </Text>
      <Button width="fixed" mt={0.5} onClick={() => router.reload()}>
        Refresh
      </Button>
    </Stack>;
};